<template>
  <div id="advantages" class="groupage-cargo">
    <page-header title="Доставка сборных грузов по России" title-in-breadcrumbs="Сборные грузы"/>
    <div class="public-container public-container-mobile">
      <groupage-cargo-props/>
      <public-order-create-button class="my-90"/>
      <groupage-cargo-info class="mb-90"/>
      <groupage-cargo-process/>
      <public-info-grid
        :title="data.title"
        :items="items"
        class="my-110"
      />
      <public-reviews />
      <contacts-terminals
        has-title
        class="my-90"
        title-without-location
        :location-guid="currentCity?.guid" 
      >
        <contacts-departments />
      </contacts-terminals>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useCityStore} from '~/stores/city'
import {getPageContent} from "~/api/content";
import PageHeader from '~~/components/public/page-header.vue'
import PublicInfoGrid from '~~/components/public/public-info-grid.vue'
import PublicOrderCreateButton from '~/components/public/public-order-create-button.vue'
import GroupageCargoInfo from '~~/components/public/groupage-cargo/groupage-cargo-info.vue'
import GroupageCargoProps from '~~/components/public/groupage-cargo/groupage-cargo-props.vue'
import GroupageCargoProcess from '~~/components/public/groupage-cargo/groupage-cargo-process.vue'
import ContactsTerminals from '~/components/public/contacts/contacts-terminals.vue'
import ContactsDepartments from '~/components/public/contacts/contacts-departments.vue'
import PublicReviews from '~/components/public/public-reviews.vue'

const { currentCity } = storeToRefs(useCityStore())

const data = (await getPageContent('/groupage-cargo')).blocks?.advantages

const items = computed(() => [
  {
    title: data.geoTitle,
    text: data.geoText,
    icon: {
      url: '/svg/vz-world.svg'
    }
  },
  {
    title: data.transportTitle,
    text: data.transportText,
    icon: {
      url: '/svg/car/vz-delivery-truck.svg'
    },
  },
  {
    title: data.priceTitle,
    text: data.priceText,
    icon: {
      url: '/svg/vz-coins.svg'
    },
  },
  {
    title: data.documentTitle,
    text: data.documentText,
    icon: {
      url: '/svg/vz-docs-success.svg'
    }
  },
  {
    title: data.termsTitle,
    text: data.termsText,
    icon: {
      url: '/svg/calendar.svg'
    }
  },
  {
    title: data.manageTitle,
    text: data.manageText,
    icon: {
      url: '/svg/vz-search-success.svg'
    }
  },
  {
    title: data.insuranceTitle,
    text: data.insuranceText,
    icon: {
      url: '/svg/vz-security.svg'
    },
  },
  {
    title: data.notifyTitle,
    text: data.notifyText,
    icon: {
      url: '/svg/mail.svg'
    }
  }
])
</script>
